// store为实例化生成的
const state = {
    codeTimer: null, // 验证码定时器
}

export default state
